import {
  GET_SURVEYCATEGORIE,
  GET_SURVEYCATEGORIE_FAIL,
  GET_SURVEYCATEGORIE_SUCCESS,
  GET_SURVEYCATEGORIES,
  GET_SURVEYCATEGORIES_FAIL,
  GET_SURVEYCATEGORIES_SUCCESS,
  ADD_NEW_SURVEYCATEGORIE,
  ADD_SURVEYCATEGORIE_SUCCESS,
  ADD_SURVEYCATEGORIE_FAIL,
  UPDATE_SURVEYCATEGORIE,
  UPDATE_SURVEYCATEGORIE_SUCCESS,
  UPDATE_SURVEYCATEGORIE_FAIL,
  DELETE_SURVEYCATEGORIE,
  DELETE_SURVEYCATEGORIE_SUCCESS,
  DELETE_SURVEYCATEGORIE_FAIL,
  SET_STATE_SURVEYCATEGORIE,
  UPDATE_SURVEYCATEGORIE_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_SURVEYCATEGORIE,
  payload: loading,
})

export const getSurveyCategories = ( params ) => ({
  type: GET_SURVEYCATEGORIES,
  payload: { params },
})

export const getSurveyCategoriesSuccess = (surveyCategories, totalPages, currentPage) => ({
  type: GET_SURVEYCATEGORIES_SUCCESS,
  payload: { surveyCategories:surveyCategories, total:totalPages, currentPage:currentPage}
})

export const getSurveyCategoriesFail = error => ({
  type: GET_SURVEYCATEGORIES_FAIL,
  payload: error,
})

export const addNewSurveyCategorie = surveyCategorie => ({
  type: ADD_NEW_SURVEYCATEGORIE,
  payload: surveyCategorie,
})

export const addSurveyCategorieSuccess = surveyCategorie => ({
  type: ADD_SURVEYCATEGORIE_SUCCESS,
  payload: surveyCategorie,
})  

export const addSurveyCategorieFail = error => ({
  type: ADD_SURVEYCATEGORIE_FAIL,
  payload: error,
})

export const updateSurveyCategorie = surveyCategorie => ({
  type: UPDATE_SURVEYCATEGORIE,
  payload: surveyCategorie,
})

export const updateSurveyCategorieStatus = surveyCategorie => ({
  type: UPDATE_SURVEYCATEGORIE_STATUS,
  payload: surveyCategorie,
})

export const updateSurveyCategorieSuccess = surveyCategorie => ({
  type: UPDATE_SURVEYCATEGORIE_SUCCESS,
  payload: surveyCategorie,
})

export const updateSurveyCategorieFail = error => ({
  type: UPDATE_SURVEYCATEGORIE_FAIL,
  payload: error,
})

export const deleteSurveyCategorie = surveyCategorie => ({
  type: DELETE_SURVEYCATEGORIE,
  payload: surveyCategorie,
})

export const deleteSurveyCategorieSuccess = id => ({
  type: DELETE_SURVEYCATEGORIE_SUCCESS,
  id,
})

export const deleteSurveyCategorieFail = error => ({
  type: DELETE_SURVEYCATEGORIE_FAIL,
  payload: error,
})

export const getSurveyCategorie = () => ({
  type: GET_SURVEYCATEGORIE,
})

export const getSurveyCategorieSuccess = surveyCategorie => ({
  type: GET_SURVEYCATEGORIE_SUCCESS,
  payload: surveyCategorie,
})

export const getSurveyCategorieFail = error => ({
  type: GET_SURVEYCATEGORIE_FAIL,
  payload: error,
})
